export default __webpack_public_path__ + "static/media/001-reloj.a46c55a0.png";